import { ListItemText } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadEstadoNomina } from "../../../../../redux/actions/nte";
import { downloadFile } from "../../../../../util/files";
import { StyledNte } from "../../../../styled/Prevencion";

const DatosDelEstablecimientoCard = ({ data }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const searchedNte = useSelector((state) => state.nte.searchedNte);

  const [isDownloadingNominas, setIsDownloadingNominas] = useState(false);

  const handleDescargarNominas = () => {
    setIsDownloadingNominas(true);
    dispatch(downloadEstadoNomina(searchedNte))
      .then((res) => {
        downloadFile(res?.value?.data, res.value.fileName).then((_) => {
          setIsDownloadingNominas(false);
        });
      })
      .catch((err) => {
        toast.error(err);
        setIsDownloadingNominas(false);
      });
  };

  return (
    <>
      <StyledNte.List>
        <StyledNte.ListItem key="nombre">
          <StyledNte.Label>
            Nombre Establecimiento
          </StyledNte.Label>
          <ListItemText
            secondary={
              data?.nombre ? data.nombre.split("-")[0] : "Sin Información"
            }
          />
        </StyledNte.ListItem>
        <StyledNte.ListItem key="domicilio">
          <StyledNte.Label>Domicilio</StyledNte.Label>
          <ListItemText
            secondary={data?.domicilio ? data?.domicilio : "Sin Información"}
          />
        </StyledNte.ListItem>
        <StyledNte.ListItem key="matrizUnica">
          <StyledNte.Label>Matriz Única</StyledNte.Label>
          <ListItemText
            secondary={data?.matrizUnica ? data.matrizUnica : "Sin Información"}
          />
        </StyledNte.ListItem>
        <StyledNte.ListItem key="codigoIntercambio">
          <StyledNte.Label>Cód. Intercambio</StyledNte.Label>
          <ListItemText
            secondary={
              data?.codigoIntercambio
                ? data?.codigoIntercambio
                : "Sin Información"
            }
          />
        </StyledNte.ListItem>
        <StyledNte.ListItem key="actividad">
          <StyledNte.Label>
            Actividad Establecimiento
          </StyledNte.Label>
          <ListItemText
            secondary={data?.actividad ? data.actividad : "Sin Información"}
          />
        </StyledNte.ListItem>
      </StyledNte.List>
    </>
  );
};

export default DatosDelEstablecimientoCard;
